import FlexxLogoImg from "../FlexxLogoImg";

const Footer = () => {
  return (
    <footer data-testid="footer" className="footer">
      <div className="footer-content">
        <FlexxLogoImg className="logo-img" alt="FLEXX Academy" />
        <p className="footer-text">
          FLEXX Academy provides educational content and community collaboration only. 
          Participation does not constitute financial advice, investment solicitation, 
          or guarantees of performance. Trading and digital assets involve risk.
        </p>
        <p className="copyright">© 2026 FLEXX Academy. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
